import React from 'react';
import { Circle, CircleMarker, MapContainer, TileLayer, Tooltip } from 'react-leaflet';
import { cn } from '../../utils/cn';
import type { ServiceArea } from '../../types/chef';
export function ServiceAreaMap({
  areas,
  center,
  className
}: {
  areas: ServiceArea[];
  center: {
    lat: number;
    lng: number;
  };
  className?: string;
}) {
  return <div className={cn('overflow-hidden rounded-xl border border-hairline', className)} data-id="element-421" data-mp="22kmx395xv79c">
      <MapContainer center={[center.lat, center.lng]} zoom={11} scrollWheelZoom={false} style={{
      height: '100%',
      width: '100%'
    }} aria-label="Service areas" data-id="element-422" data-mp="2h9svww0v6vgp">
        <TileLayer url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>' data-id="element-423" data-mp="2qa7ugx2ua725" />
        {areas.map(area => <React.Fragment key={area.id} data-id="element-424" data-mp="ryip0bw8i2uc">
            <Circle center={[area.lat, area.lng]} radius={area.radiusKm * 1000} pathOptions={{
          color: area.travelIncluded ? '#3A4A33' : '#B24720',
          fillColor: area.travelIncluded ? '#3A4A33' : '#B24720',
          fillOpacity: 0.1,
          weight: 1.5,
          dashArray: area.travelIncluded ? undefined : '4 4'
        }} data-id="element-425" data-mp="2cm7rlnshqk2s" />
            <CircleMarker center={[area.lat, area.lng]} radius={6} pathOptions={{
          color: '#FDF8F0',
          weight: 2,
          fillColor: '#3A4A33',
          fillOpacity: 1
        }} data-id="element-426" data-mp="2w95f7vsrlea4">
              <Tooltip direction="top" offset={[0, -6]} data-id="element-427" data-mp="35b6boqg6bwaq">
                <span className="font-semibold" data-id="element-428" data-mp="3a9pzkwebvi5q">{area.name}</span>
                <br data-id="element-429" data-mp="3a73sexvcn4o1" />
                {area.travelIncluded ? 'Travel included' : 'Mileage applies'}
              </Tooltip>
            </CircleMarker>
          </React.Fragment>)}
      </MapContainer>
    </div>;
}